import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { logoutApi } from "../../api/authService";
import Dropdown from "react-bootstrap/Dropdown";
import PageHeading from "./PageHeading";
class Header extends Component {
  handleLogout = async (e) => {
    e.preventDefault();

    try {
      await logoutApi();
    } catch (error) {
      console.warn("Server logout was unavailable; completing local sign out.");
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("role");
      localStorage.removeItem("permissions");
      sessionStorage.clear();

      window.location.replace("/login");
    }
  };
  render() {
    const { fixNavbar, darkHeader, pageTitle, breadcrumbs } = this.props;
    return (
      <div>
        <div
          id="page_top"
          className={` ${fixNavbar ? "sticky-top" : ""} ${darkHeader ? "top_dark" : ""}`}
        >
          <div className="page-header np-admin-page-header np-admin-header-inner">
            <PageHeading title={pageTitle} breadcrumbs={breadcrumbs} />
            <div className="right np-admin-page-actions">
              <div className="d-flex ml-auto float-right">
                <Dropdown align="end">
                  <Dropdown.Toggle
                    variant="default"
                    className="nav-link icon d-none d-md-flex btn btn-default btn-icon"
                    id="dropdown-user"
                  >
                    <i className="fa fa-user" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu-arrow">
                    <NavLink to="/profile" className="dropdown-item">
                      <i className="dropdown-icon fe fe-user" /> Profile
                    </NavLink>
                   
                    <Dropdown.Item
                      as="button"
                      className="dropdown-item"
                      onClick={this.handleLogout}
                    >
                      <i className="dropdown-icon fe fe-log-out" /> Sign out
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
  darkHeader: state.settings.isDarkHeader,
});
const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Header);
